// The Projects singleton tab's centre (#161): All projects
// (useProjectItems.ts), with pins shared with the left menu and this page's
// own sort and view (Cards | Table), kept per device (projectsPreference.ts).
// Opening a project opens the Studio on it, where the author was; with none
// yet, the empty state sets up a new one.

import type { ReactNode } from "react";
import { ProjectsPage } from "../../../components/Projects/ProjectsPage.js";
import { RemoveProjectDialog } from "../../../components/Projects/RemoveProjectDialog.js";
import { useProjectsView } from "../../projectsPreference.js";
import { useProjectItems } from "../chrome/useProjectItems.js";
import { useAppShell } from "../context.js";

export const ProjectsCentre = (): ReactNode => {
    const { library } = useAppShell();
    const projects = useProjectItems();
    const [view, onView] = useProjectsView();
    return (
        <>
            <RemoveProjectDialog {...projects.removal} />
            <ProjectsPage
                items={projects.items}
                archived={projects.archived}
                summaryOf={(id) => projects.summaries.get(id)}
                pins={projects.view}
                onPinsCommand={projects.onCommand}
                view={view}
                onView={onView}
                loading={library === null}
                onNewProject={projects.newProject}
            />
        </>
    );
};
